import LogoTitle from '../../assets/images/logo-e.png';
import { Link } from 'react-router-dom';
import './index.scss';
import { useEffect, useState } from 'react';
import AnimatedLetters from '../AnimatedLetters';
import Logo from './Logo'
import Loader from 'react-loaders'



const Home = () => {

    const [letterClass, setLetterClass] = useState('text-animate')
    const nameArray = [' ','E', 'r', 'i', 'c',' ', 'T', 'i', 'l', 't', 'o','n']
    const jobArray=['w','e','b',' ','d','e','v','e','l','o','p','e','r','.']



  useEffect(() => {
           setTimeout (() => {
           return setLetterClass('text-animate-hover')
          }, 5000)
   }, [])

return (
<>
<div className="container home-page">
<div className="text-zone">
<h1>
<span className={letterClass}>H</span>
<span className={`${letterClass} _12`}>i,</span>
<br/>

<span className={`${letterClass} _13`}>I</span>
<span className={`${letterClass} _14`}>'m</span>


<AnimatedLetters letterClass={letterClass}
strArray={nameArray}
idx={15}/>
<br />
<AnimatedLetters letterClass={letterClass}
strArray={jobArray}
idx={27}/>

</h1>
<h2>Frontend Developer / Backend Developer / Marine Corps Veteran </h2>
<Link to="/contact" className="flat-button">CONTACT ME</Link>
</div>
<Logo />
</div>

<Loader type="ball-grid-pulse" />
</>
);

}


export default Home